import { ref } from 'vue'

export const useSelectFilter = () => {
  const filters = ref([])

  const selectedFilters = ref([])

  const setFilters = filtersProps => {
    filters.value = [...filtersProps]
  }

  return { filters, selectedFilters, setFilters }
}
